<template>
  <el-dialog
    :title="rowData.userName"
    :visible.sync="dialogVisible"
    width="40%"
    class="editEmployeeDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="editEmployeeDialogForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="角色" prop="roles">
            <el-select
              class="special"
              v-model="formData.roles"
              filterable
              placeholder="请选择"
              clearable
              multiple
            >
              <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.roleId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="分管行业">
            <el-checkbox-group v-model="formData.manageIndustrys">
              <el-checkbox v-for="item in industrysList" :key="item.fieldKey" :label="item.fieldValue" name="industrys" />
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="分管产品线">
            <el-checkbox-group v-model="formData.manageProductLines">
              <el-checkbox v-for="item in productLineList" :key="item.fieldKey" :label="item.fieldValue" name="productLine" />
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { roleManagementApi } from '../../service';

  export default {
    data () {
      return {
        rules: {
          roles: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ]
        },
        dialogVisible: false,
        formData: {
          manageIndustrys: [],
          manageProductLines: []
        },
        roleList: [],
        productLineList: [],
        industrysList: []
      };
    },
    props: {
      editEmployeeShow: {
        type: Boolean,
        default: false
      },
      rowData: {
        tupe: Object,
        default: () => {
          return {};
        }
      }
    },
    watch: {
      editEmployeeShow (val) {
        if (val) {
          this.formData.manageIndustrys = this.rowData.manageIndustrys;
          this.formData.manageProductLines = this.rowData.manageProductLines;
          this.formData.userId = this.rowData.userId;
          this.formData.userName = this.rowData.userName;
          this.$set(this.formData, 'roles', this.rowData.roles.map(item => {
            return item.roleId;
          }));
          this.getIndustryList();
          this.getProductLineList();
          this.getRoleList();
          this.$nextTick(() => {
            this.$refs.editEmployeeDialogForm.clearValidate();
          });
        } else {
          this.formData = {
            manageIndustrys: [],
            manageProductLines: []
          };
        }
        this.dialogVisible = val;
      }
    },
    methods: {
      submitHandle () {
        this.$refs['editEmployeeDialogForm'].validate((valid) => {
          if (valid) {
            this.$emit('submitHandle', this.formData);
          }
        });
      },
      getRoleList () {
        roleManagementApi.getRoleList().then(res => {
          if (res.status === '200') {
            this.roleList = res.data;
          }
        });
      },
      getProductLineList () {
        roleManagementApi.getConfigureList('manage_product_line').then(res => {
          if (res.status === '200') {
            this.productLineList = res.data;
          }
        });
      },
      getIndustryList () {
        roleManagementApi.getConfigureList('manage_industry').then(res => {
          if (res.status === '200') {
            this.industrysList = res.data;
          }
        });
      },
      dialogCloseHandle () {
        this.$emit('dialogCloseHandle');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .editEmployeeDialog{
    ::v-deep.el-dialog{
      margin-top: 20vh!important;
      .el-dialog__body{
        min-height: 240px;
        .special > .el-input{
          height: auto;
        }
      }
    }
  }
</style>
